import Header from './header/header.vue'
import LeftMenu from './menu/left-menu.vue'
import MainFooter from './footer/main-footer.vue'
import MainFooterOrenb from './footer/region.orenb/main-footer.vue'

import region from '../utils/region.js'
import {ORENB} from '../config/region.js'

export default function (Vue) {
  let currentRegion = region.getCurrentRegion()

  Vue.component(Header.name, Header)
  Vue.component(LeftMenu.name, LeftMenu)

  Vue.component(MainFooter.name, MainFooter)

  // example
  if (currentRegion === ORENB) {
    Vue.component(MainFooterOrenb.name, MainFooterOrenb)
  }
}